import axios from 'axios';

// Development vs Production Base URL
const BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';

export const api = axios.create({
  baseURL: BASE_URL,
  // NOTE: Do NOT set default Content-Type here.
  // Axios auto-detects: JSON for objects, multipart/form-data for FormData.
  // Setting 'application/json' globally breaks file uploads on some mobile browsers.
});

// Request Interceptor: Add JWT Token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('erp_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response Interceptor: Handle 401 Unauthorized globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Don't clear session for the login request itself (wrong password != expired token)
      const isLoginRequest = url.includes('/auth/login');

      if (!isLoginRequest) {
        console.warn(`Unauthorized (401) on ${url}. Token expired — clearing session.`);
        const hasToken = !!localStorage.getItem('erp_access_token');
        if (hasToken) {
          localStorage.removeItem('erp_access_token');
          localStorage.removeItem('erp_user');
          window.dispatchEvent(new Event('erp_unauthorized'));
        }
      }
    }
    return Promise.reject(error);
  },
);

export default api;
